import React, { Suspense, useMemo } from 'react';
import { Outlet } from 'react-router';
import { shallowEqual, useSelector } from 'react-redux';
import WafErrorModal from './app/shared/component/WafErrorModal';
import { Slide, ToastContainer } from 'react-toastify';
import { Badge, Col, Container, Row } from 'react-bootstrap';
import { Header } from './app/shared/component/layout/header';
import { ApplicationLoader } from './app/shared/component/loader/application-loader';
import { useTranslation } from 'react-i18next';

const MainLayout = () => {
  const file = useSelector((state: any) => state.file, shallowEqual);
  const headerColor = process.env.REACT_APP_HEADER_COLOR;

  const { t } = useTranslation('translation');

  const issuersNames = useMemo(
    () =>
      file.legalEntities &&
      (file.legalEntities as any[])
        .filter((entity: any) => entity.category === 'ISSUER')
        .map((entity: any) => {
          if (entity.name) {
            return entity.branch ? entity.name + ' ' + entity.branch : entity.name;
          } else return '';
        })
        .filter((value) => value && value.trim() !== '')
        .join(' / '),
    [file.legalEntities]
  );
  // useEffect(() => {api.metrics.access()}, []);
  return (
    <>
      <WafErrorModal />
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        <ToastContainer transition={Slide} />
      </div>
      <header>
        <div className="jumbotron cssf-jumbotron-home" style={{ backgroundColor: headerColor }}>
          <Container fluid className="cssf-jumbotron-home-overlay">
            <div className="cssf-jumbotron-left-title h-100 d-flex justify-content-center ps-3">
              <div className="d-flex align-items-center">
                <span className=" me-4">
                  <img style={{ height: '20px' }} src={`${process.env.PUBLIC_URL}/img/logo-cssf-white.png`} alt={'CSSF'} />
                </span>

                <h4>{t('home.title')}</h4>
                {process.env.REACT_APP_BADGE_ENV_TEXT && (
                  <h4>
                    <Badge className="ms-2" pill bg={process.env.REACT_APP_BADGE_ENV_COLOR}>
                      {process.env.REACT_APP_BADGE_ENV_TEXT}
                    </Badge>
                  </h4>
                )}
              </div>
            </div>
            <Row>
              <Col md="2" />
              <Col md="8">
                {issuersNames && (
                  <div className="cssf-jumbotron-middle-title">
                    <h4 className="d-flex justify-content-center">
                      <p className="text-truncate mb-0 text-center">{issuersNames}</p>
                    </h4>
                  </div>
                )}
              </Col>

              <Col md="2">
                <div className="cssf-jumbotron-right-title">
                  <Header />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </header>
      <Suspense fallback={<ApplicationLoader />}>
        <Outlet />
      </Suspense>
    </>
  );
};

export default MainLayout;
